﻿import React, {Component} from 'react';
import FeedSourceDetails from './feed-source-details'
import PropTypes from "prop-types";

class FeedSource extends Component {
    render() {
        return (
            <FeedSourceDetails />
        )
    }
}

FeedSource.contextTypes = {
    router: PropTypes.any.isRequired
};

export default FeedSource;